import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuthStore } from "../../auth/hooks";
import { useForm } from "../../hooks";
import { AuthLayout } from "../layout";
import {
  InputForm,
  LoadingData,
  ErrorMessage,
  MainButton,
  SuccessMessage,
} from "../ui";
import { useFormMessages } from "../hooks";

const formData = {
  email: "",
  password: "",
};

// const formData = {
//   email: "hernandezmahechaoscar0@gmail.com",
//   password: "Oscar123",
// };

const formValidations = {
  email: [(value) => value.includes("@"), "El email debe contener una @"],
  password: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
};

export const LoginPage = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoading,
    message,

    // Methods
    startLogin,
  } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { setFormSubmitted, showErrorMessage, messageText } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onLogin = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startLogin(formState);
    }
  };
  // Efectos -----------------------------------------------//

  return (
    <AuthLayout>
      <h4 className="text-center">Ingresa</h4>
      <form className="login-form mt-4" onSubmit={onLogin}>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-12">
              <InputForm
                label={"Correo electrónico"}
                type={"text"}
                validation={formValidation.emailValid}
                submit={validateForm}
                name={"email"}
                value={formState.email}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Contraseña"}
                type={"password"}
                validation={formValidation.passwordValid}
                submit={validateForm}
                name={"password"}
                value={formState.password}
                onInputChange={onInputChange}
              />
            </div>
          </>

          {/* Redirecciones */}
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <Link to="/auth/activate-account" className="text-black fw-bold">
                Activa tu cuenta
              </Link>
              <Link to="/auth/forgot-password" className="text-dark fw-bold">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="d-grid">
              <MainButton type="submit" disabled={isLoading}>
                Ingresar
              </MainButton>
            </div>
          </div>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
            {message?.type === "login-message" && (
              <div className="col-md-12">
                <SuccessMessage>{message.text}</SuccessMessage>
              </div>
            )}
          </>

          <div className="col-lg-12 text-center">
            <h6 className="text-muted mb-0">O</h6>
          </div>
          <div className="col-12 text-center">
            <small className="text-dark me-2">¿No tienes cuenta ?</small>{" "}
            <Link to="/auth/signup" className="text-dark fw-bold">
              Regístrate
            </Link>
          </div>
        </div>
      </form>
    </AuthLayout>
  );
};
